import React from "react";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";

import Button from "@material-ui/core/Button";

//import "../../assets/css/customstyles.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

 function KnowledgeList(props) {
   
  const classes = useStyles();
  const { t } = props;
  let history = useHistory();
  let menuItem  = props.knowledgeObj.contentList[0];

  // function handleClick() {
  //   console.log('KnowledgeList handleClick>>', props)
  //   history.push({
  //     pathname: "/layout/getknowledgeableDetail",
  //     state: props.knowledgeObj,
  //   });
  // }

  function handleClick() {
    try{
      if(props.knowledgeObj.hasChild) {
        if(props.knowledgeObj.contentList.length == 0) {
          props.setSelectedComponentObject({id: props.knowledgeObj.contentId});
          history.push({
            pathname: "/layout/getknowledgeable/child",
            state: {id: props.knowledgeObj.contentId},
          });
        } else {
          history.push({
            pathname: "/layout/getknowledgeableDetail",
            state: props.knowledgeObj,
          });
        }
      } else {
        history.push({
          pathname: "/layout/getknowledgeableDetail",
          state: props.knowledgeObj,
        });
      }
    }catch(err){
      console.log("err::", err)
    }
  }

  function getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    return myUrl;
  }

  return (
    <>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar alt={menuItem.title} src={getHttpsUrl(menuItem.logoURL)} />
        </ListItemAvatar>
        <ListItemText
          primary={menuItem.title}
          style={{ color: props.componentbgcolor }}
          className="infotitle"
          secondary={
            <React.Fragment>
              <Typography
                component="span"
                variant="body2"
                className="infodesc"
                color="textPrimary"
              >
                {menuItem.shortDesc}
              </Typography>
              <Typography
                component="span"
                variant="body2"
                className="infoupdatedate"
                color="textPrimary"
              >
                {menuItem.date}
              </Typography>
              <Typography
                component="span"
                variant="body2"
                className={classes.inline}
                color="textPrimary"
              >
                <Button
                style={{ background: props.componentbgcolor }}
                  variant="contained"
                  color="primary"
                  disableElevation
                  className="infoviewmorebtn"
                  onClick={handleClick}
                >
                 <Trans> {t("View More")} </Trans>
                </Button>
              </Typography>
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
    </>
  );
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};



const transKnowYourRightsDetail = withTranslation()(KnowledgeList);
export default connect(mapStateToProps, {})(transKnowYourRightsDetail);